'use strict';
import angular from 'angular';
import './scripts/formlist.ctrls';
import '../../scripts/shared/formFields.directives';

import formListHtmlUrl from './views/formList.html';
import formListGroupsHtmlUrl from './views/formListGroups.html';
import formListLookupHtmlUrl from './views/formListLookup.html';

angular.module('formlist', [
    'formlist.ctrls',
    'formFields.directives'
])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('formList', {
                parent: 'layout',
                url: '/admin/formList',
                templateUrl: formListHtmlUrl,
                controller: 'FormListController',
            })
            .state('formListGroups', {
                parent: 'layout',
                url: '/admin/formListGroups/:formId/:contentTypeId',
                templateUrl: formListGroupsHtmlUrl,
                controller: 'FormListGroupsController',
                params: {
                    message: null
                }
            })
            .state('formListLookup', {
                parent: 'layout',
                url: '/admin/formListLookup/:formId',
                templateUrl: formListLookupHtmlUrl,
                controller: 'FormListLookupController',
                params: {
                    message: null,
                    contentTypeId: 'contentTypeId'
                }
            })
    }]);